import {
  GET_FAQS_START,
  GET_FAQS_SUCCESS,
  GET_FAQS_ERROR,
  GET_FAQ_BY_ID_START,
  GET_FAQ_BY_ID_SUCCESS,
  GET_FAQ_BY_ID_ERROR,
  CREATE_FAQ_START,
  CREATE_FAQ_SUCCESS,
  CREATE_FAQ_ERROR,
  EDIT_FAQ_START,
  EDIT_FAQ_SUCCESS,
  EDIT_FAQ_ERROR,
  DELETE_FAQ_START,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_ERROR,
} from '../actions/faq/faq.actiontype';

export default function (state = { list: [] }, action) {
  switch (action.type) {
    case GET_FAQS_START:
      return {
        ...state,
        isFetching: true,
      };
    case GET_FAQS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload,
      };
    case GET_FAQS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case GET_FAQ_BY_ID_START:
      return {
        ...state,
        isFetchingOne: true,
      };
    case GET_FAQ_BY_ID_SUCCESS:
      return {
        ...state,
        isFetchingOne: false,
        currentFaq: action.payload,
      };
    case GET_FAQ_BY_ID_ERROR:
      return {
        ...state,
        isFetchingOne: false,
      };
    case CREATE_FAQ_START:
      return {
        ...state,
        isCreating: true,
      };
    case CREATE_FAQ_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: [...state.list, action.payload],
      };
    case CREATE_FAQ_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case EDIT_FAQ_START:
      return {
        ...state,
        isCreating: true,
      };
    case EDIT_FAQ_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: state.list.map(faq => {
          if (faq.id === action.payload.id) {
            return action.payload;
          }
          return faq;
        }),
      };
    case EDIT_FAQ_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case DELETE_FAQ_START:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_FAQ_SUCCESS:
      const newList = state.list.filter(faq => faq.id !== action.payload.id);
      return {
        ...state,
        isDeleting: false,
        list: newList,
      };
    case DELETE_FAQ_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
